import { render, staticRenderFns } from "./v-register.vue?vue&type=template&id=420e1f97&"
import script from "./v-register.vue?vue&type=script&lang=js&"
export * from "./v-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports